import React from 'react';
import { upperFirst } from 'lodash';
import Tooltip from './Tooltip';
import StatusBadge from './StatusBadge';
import getChargeStatusLabel from '@dashboard/services/status/getChargeStatusLabel';
import isRecoveredAbandonment from '../services/abandonment/isRecoveredAbandonment';
import isAbandonedAbandonment from '../services/abandonment/isAbandonedAbandonment';
import { formatDateTime } from '../lib/format-date';

export function PaymentStatusBadges({ payment }) {
  const { orderStatus, status, livemode, paymentError, isComplimentary } = payment;
  const isCanceled = orderStatus === 'canceled';
  const isRefunded = status === 'refunded' || status === 'partial_refund';
  const isAbandoned = isAbandonedAbandonment(payment);
  const isRecovered = isRecoveredAbandonment(payment);
  const label = getChargeStatusLabel(status);

  const abandonmentBadge = (() => {
    if (isAbandoned) {
      return <StatusBadge status="abandoned" label="Abandoned" />;
    }

    if (isRecovered) {
      return (
        <Tooltip label={`Recovered on ${formatDateTime(payment.recoveredAt)}`}>
          <StatusBadge status="recovered" label="Recovered" withInfoIcon />
        </Tooltip>
      );
    }
    return null;
  })();

  const complimentaryBadge = isComplimentary ? (
    <Tooltip label="Complimentary booking">
      <StatusBadge status="complimentary" label="Comp" />
    </Tooltip>
  ) : null;

  const archivedBadge =
    payment.archivedAt != null ? (
      <Tooltip label={`Archived on ${formatDateTime(payment.archivedAt)}`}>
        <StatusBadge status="archived" label="Archived" />
      </Tooltip>
    ) : null;

  if (isCanceled && !isRefunded) {
    return (
      <>
        {abandonmentBadge != null && abandonmentBadge}
        <StatusBadge status={orderStatus} label={upperFirst(orderStatus)} livemode={livemode} />
        {complimentaryBadge}
        {archivedBadge}
      </>
    );
  }

  if (isCanceled && isRefunded) {
    return (
      <>
        {abandonmentBadge != null && abandonmentBadge}
        <StatusBadge status={orderStatus} label={upperFirst(orderStatus)} livemode={livemode} />
        <StatusBadge status={status} label={label} livemode={livemode} />
        {complimentaryBadge}
        {archivedBadge}
      </>
    );
  }

  return (
    <>
      {abandonmentBadge != null && abandonmentBadge}
      <Tooltip
        triggerClassName={abandonmentBadge != null ? 'gap-x-2 flex flex-row' : ''}
        label={paymentError}
        side="right"
      >
        <StatusBadge status={status} label={label} livemode={livemode} />
      </Tooltip>
      {complimentaryBadge}
      {archivedBadge}
    </>
  );
}
